module.exports = __webpack_public_path__ + "static/media/passculture.d75a2e82.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Cart/passculture.png
// module id = 559
// module chunks = 0